import {all, takeEvery} from "redux-saga/effects";
import {validateStatementCategorization} from "./saga/validateStatementCategorization";
import {VALIDATE_STATEMENT_CATEGORIZATION} from "./actionTypes";

export default function* saga() {
    yield all([
        yield takeEvery(VALIDATE_STATEMENT_CATEGORIZATION, validateStatementCategorization),
    ]);
}
